import { CommonModule, DatePipe } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { I18nModule, UrlModule, ConfigModule } from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { SpinnerModule, IconModule, MediaModule } from '@spartacus/storefront'
import { OrderTrackingDetailComponent } from './order-tracking-detail/order-tracking-detail.component'
import { AddressDetailsComponent } from './order-tracking-detail/address-details/address-details.component'
import { LineItemsComponent } from './order-tracking-detail/line-items/line-items.component'
import { OrderTrackingProductComponent } from './order-tracking-detail/order-tracking-product/order-tracking-product.component'
import { OrderTrackingService } from './order-tracking.service'
import { OrderTrackingListComponent } from './order-tracking-list/order-tracking-list.component'
import { AssociatedDocumentsComponent } from './order-tracking-detail/associated-documents/associated-documents.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { ScrollContainerModule } from '../../shared/components/scroll-container/scroll-container.module'
import { StatusBubbleModule } from '../../shared/components/status-bubble/status-bubble.module'
import { QuantityCounterModule } from '../../shared/components/quantity-counter'
import { ClickOutsideModule } from '../../shared/directive/clickOutside/click-outside.module'
import { StatusTilesModule } from '../../shared/components/status-tiles/status-tiles.module'
import { DateRangePickerModule } from '../../shared/components/date-range-picker/date-range-picker.module'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [
    AddressDetailsComponent,
    LineItemsComponent,
    OrderTrackingProductComponent,
    OrderTrackingDetailComponent,
    OrderTrackingListComponent,
    AssociatedDocumentsComponent,
  ],
  imports: [
    CommonModule,
    SpinnerModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    ScrollContainerModule,
    MediaModule,
    StatusBubbleModule,
    QuantityCounterModule,
    ClickOutsideModule,
    FormsModule,
    StatusTilesModule,
    DateRangePickerModule,
    ReactiveFormsModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['orderTracking'],
        },
      },
    }),
  ],
  providers: [OrderTrackingService, DatePipe],
  exports: [OrderTrackingListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderTrackingModule {}
